type Alignment = 'start' | 'center' | 'end';

/** L'abscisse reste celle du point ; seul l'alignement du texte change près des bords. */
function alignment(position: number, width: number): Alignment {
  return position < width / 2 ? 'start' : position > 100 - width / 2 ? 'end' : 'center';
}

export function axisLabelBounds(position: number, width: number): [number, number] {
  const align = alignment(position, width);
  return align === 'start' ? [position, position + width] : align === 'end' ? [position - width, position] : [position - width / 2, position + width / 2];
}

/** Conserver les bornes et ménager assez d'espace entre les libellés affichés. */
export function axisLabelIndices(positions: number[], width: number): Set<number> {
  if (!positions.length) return new Set();
  if (positions.length === 1) return new Set([0]);
  const last = positions.length - 1;
  const indices = [0];
  const bounds = positions.map((position) => axisLabelBounds(position, width));
  for (let index = 1; index < last; index += 1) {
    if (bounds[index]![0] - bounds[indices[indices.length - 1]!]![1] >= 1 && bounds[last]![0] - bounds[index]![1] >= 1) indices.push(index);
  }
  indices.push(last);
  return new Set(indices);
}

export function ChartAxisLabels({ labels, compactLabels, position }: { labels: string[]; compactLabels?: string[]; position: (index: number) => number }) {
  const positions = labels.map((_, index) => position(index));
  const compact = axisLabelIndices(positions, 22);
  const wide = axisLabelIndices(positions, 13);
  const mobileAlignment: Record<Alignment, string> = { start: 'translate-x-0', center: '-translate-x-1/2', end: '-translate-x-full' };
  const wideAlignment: Record<Alignment, string> = { start: '@sm:translate-x-0', center: '@sm:-translate-x-1/2', end: '@sm:-translate-x-full' };
  return <div className="relative mt-1 h-5 text-[10px] text-slate-600" aria-hidden>
    {labels.map((label, index) => <span key={index} data-axis-label className={`absolute max-w-[22%] truncate text-center @sm:max-w-[13%] ${mobileAlignment[alignment(positions[index]!, 22)]} ${wideAlignment[alignment(positions[index]!, 13)]} ${compact.has(index) ? '' : 'invisible'} ${wide.has(index) ? '@sm:visible' : '@sm:invisible'}`} style={{ left: `${positions[index]}%` }}>{compactLabels ? <><span className="@lg:hidden" data-axis-compact-label>{compactLabels[index] ?? label}</span><span className="hidden @lg:inline" data-axis-full-label>{label}</span></> : label}</span>)}
  </div>;
}
